import { AuthRequest, ResponseType } from 'expo-auth-session';

import { idMeConfig } from '../../config';
import { buildAuthorizeUrl } from '../build-authorize-url';

// ─────────────────────────────────────────────────────────────────────────────

export async function createIdMeAuthorizationRequest(params: Params) {
  const { scopes } = params;

  const { clientId, redirectUri, discovery } = idMeConfig;

  const authRequest = new AuthRequest({
    clientId,
    redirectUri,
    scopes: [...scopes],
    responseType: ResponseType.Code,
    usePKCE: true,
  });

  // NOTE: Also sets up PKCE, so it has to run before the URL is assembled.
  const config = await authRequest.getAuthRequestConfigAsync();

  const url = buildAuthorizeUrl({
    authorizationEndpoint: discovery.authorizationEndpoint,
    config,
  });

  const { codeVerifier } = authRequest;

  if (!codeVerifier) {
    throw new Error('missing_code_verifier');
  }

  return {
    url,
    authRequest,
    redirectUri,
    state: authRequest.state,
    codeVerifier,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  scopes: readonly string[];
};
